import apiClient from './apiClient'



// Fetch pipeline details
const getPipelines = async (apmid) => {
  // if (API_CONFIG.useMockData) {
  //   console.log('📦 Using mock data: pipelines', apmid)
  //   return delay(mockPipelines[1] || [])
  // }
  
  const response = await apiClient.get(`/Pipeline/${apmid}`)
  return response.data
}

const pipelineService = {
  getPipelines,
}

export default pipelineService
